/**
 * Tujuan: Root application component — router setup, global CSS imports, page-level layout
 * Caller: index.js (React entry point)
 * Dependensi: react-router-dom, all page components, all CSS files
 * Main Functions: App()
 * Side Effects: None
 */
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Certifications from "./pages/Certifications";

/* Bootstrap base */
import "bootstrap/dist/css/bootstrap.min.css";

/* CSS cascade order: global vars → navbar → page styles → component overrides */
import "./styles/global.css";
import "./styles/navbar.css";
import "./styles/home.css";
import "./styles/about.css";
import "./styles/Projects.css";
import "./styles/projectDetail.css";
import "./styles/components.css";

function App() {
  return (
    <Router>
      <NavBar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/project" element={<Projects />} />
        <Route path="/certifications" element={<Certifications />} />
        <Route path="/project/:slug" element={<ProjectDetail />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
